import ButtonWithIcon from "./ButtonWithIcon";

export default ButtonWithIcon;
